<template>
  <el-dialog :title="title" :visible.sync="sbvisible" :append-to-body="true" width="40%">
    <div class="tipsBox">
      <img style="width: 20px; height: 20px" src="./static/tips.png" />
      <span>支持通过司机姓名、手机号搜索司机！</span>
    </div>
    <el-form ref="form" :model="form" size="small" label-width="80px">
      <el-row :gutter="24">
        <el-col :span="24" v-if="info.orderStatus === 3">
          <el-form-item label="原司机:">
            <span
              v-if="info.driverOperationInfoList !== null && info.driverOperationInfoList.length"
            >
              {{ info.driverOperationInfoList[0].driverName }}
              {{ info.driverOperationInfoList[0].driverPhone }}
              {{ info.driverOperationInfoList[0].plateNumber }}
              {{ info.driverOperationInfoList[0].merchantName }}
            </span>
            <span v-else></span>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="选择：" prop="driverId">
            <avue-select
              v-model="info.driverId"
              :dic="driverDic"
              :props="{ label: 'driverInfo', value: 'driverId' }"
              placeholder="试试搜索: 请选择司机"
              filterable
              @change="handleChange"
              style="width: 30vw"
            />
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="备注:" prop="operationRemark">
            <el-input
              type="textarea"
              :rows="2"
              v-model="form.operationRemark"
              placeholder="备注"
              style="width: 30vw"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="font-12 margin-left-25" style="color: #9f9f9f">
      <div>指派/改派查询车司信息:</div>
      <div>1、城际车：只能被指派/改派，自己所服务的班次的摆渡订单，且司机、车辆状态正常</div>
      <div>2、摆渡车：司机、车辆所属供应商有对应线路、对应区域的接送计价，且司机、车辆状态正常</div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="danger" size="small" @click="cancel">取 消</el-button>
      <el-button type="primary" size="small" @click="sumit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import { sendOrder, getServiceDriver } from '@/api/order'
  export default {
    name: 'orderSend',
    data() {
      return {
        sbvisible: false,
        title: '',
        driverDic: [],
        query: {
          driverInfo: '',
          orderNo: ''
        },
        info: {},
        // 表单
        form: {
          driverId: '',
          orderId: 0,
          operationRemark: ''
        }
      }
    },
    methods: {
      init(row, driverDic) {
        this.sbvisible = true
        this.driverDic = driverDic
        this.info = row
        this.title = (() => (this.form.orderStatus === 3 ? '改派' : '派单'))()
        this.query.orderNo = row.orderNo
        this.form.orderId = Number.parseInt(row.orderId)
        // this.getSerDriver(row.orderId)
      },

      // 获取正在服务的司机
      getSerDriver(orderId) {
        getServiceDriver(orderId).then((resp) => {
          // console.log(resp.data);
        })
      },
      sumit() {
        sendOrder(this.form).then((resp) => {
          if (resp.code === 1) {
            this.$message.error(resp.msg || '出错了，请重试！')
            return
          }
          if (resp.code === 0) {
            this.$message.success('派单成功')
            this.$emit('refresh')
            this.sbvisible = false
            this.$refs.sendForm.resetFields()
          }
        })
      },
      // 取消
      cancel() {
        this.form.driverId = ''
        this.sbvisible = false
      },
      handleChange(val) {
        this.form.driverId = Number.parseInt(val)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .tipsBox {
    display: flex;
    align-items: center;
    font-size: 13px;
    color: #9f9f9f;
    margin: 0 0 5px 80px;
  }
  .tipsBox span {
    margin-left: 5px;
  }
  ::v-deep .el-input--small .el-input__inner {
    height: 50px;
  }
</style>
